export default __webpack_public_path__ + "static/media/welcome-video-thumbnail.280ca688.jpg";